import { BindAll } from 'lodash-decorators'

@BindAll()
export class MyAccountCoinController {
  public onReset(): void {}
}
